<template>
  <div>
    <b-row>
      <b-col cols="12" md="auto">
        <vs-card>
          <b-button
            style="border-color: white; width: 100%"
            v-on:click="printBarcode()"
            class="bg-warning"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("Print") }}
          </b-button>
        </vs-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div ref="printMeBarcode">
          <vs-card>
            <table class="custom-table">
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 12px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("invoiceNumber") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 12px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ InvoiceNumber }}
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("OrderSource") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ OrderSource }}
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("OrderNumber") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ OrderNumber }}
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("InvoiceName") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ InvoiceName }}
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("InvoiceLastName") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ InvoiceLastName }}
                </td>
              </tr>

              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("InvoiceAddress") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  <h6 style="font-size: 15px">{{ InvoiceAddress }}</h6>
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("OrderCargoName") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  <h6 style="font-size: 15px">{{ OrderCargoName }}</h6>
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("OrderDate") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  <h6 style="font-size: 15px">{{ OrderDate }}</h6>
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("OrderBarcodes") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  <h6 style="font-size: 15px">{{ OrderBarcodes }}</h6>
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("OrderCargoNumber") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  <h6 style="font-size: 15px">{{ OrderCargoNumber }}</h6>
                </td>
              </tr>
              <tr>
                <th
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  {{ $t("TotalPrice") }} :
                </th>
                <td
                  class="border-item"
                  style="
                    padding: 8px;
                    border: 1px solid black;
                    border-radius: 5px;
                    font-size: 15px;
                    font-weight: bold;
                  "
                >
                  <h6 style="font-size: 15px">{{ TotalPrice }}</h6>
                </td>
              </tr>

              <tr v-if="OrderCargoNumber" style="margin-top: 150px">
                <td class="border-item barcode-container" colspan="2">
                  <div style="width: 100%; height: auto">
                    <barcode
                      :value="OrderCargoNumber"
                      format="CODE128"
                      tag="svg"
                      :width="4"
                      :height="150"
                      :text-options="{ fontSize: 1000 }"
                      style="width: 100%; height: auto"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </vs-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import Barcode from "vue-barcode";
export default {
  components: {
    Barcode,
    Icon,
  },
  props: {
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      Items: [],
      OrderNumber: "",
      OrderCargoNumber: "",
      TotalPrice: "",
      OrderDate: "",
      OrderCargoName: "",
      InvoiceAddress: "",
      InvoiceLastName: "",
      InvoiceName: "",
      OrderSource: "",
      OrderBarcodes: "",
      InvoiceNumber: "",
      findedOrderItem: [],
    };
  },
  methods: {
    printBarcode() {
      const printContents = this.$refs.printMeBarcode.innerHTML;
      const originalContents = document.body.innerHTML;

      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write("<html><head><title>Print</title>");
      printWindow.document.write("</head><body >");
      printWindow.document.write(printContents);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },
    getOrderDetails(item, isList) {
      const vm = this;
      if (isList == true) {
        this.setDetails();
      } else {
        this.orderDetailList = item;
        this.setDetails();
      }
    },
    setDetails() {
      this.OrderBarcodes = "";
      this.findedOrderItem = this.orderDetailList.Items;
      for (let index = 0; index < this.findedOrderItem.length; index++) {
        this.findedOrderItem[index].orderItemRead = 0;
        this.OrderBarcodes +=
          this.findedOrderItem[index].OrderItemBarcode +
          "(" +
          this.findedOrderItem[index].OrderItemQuantity +
          " adet) ";
      }
      this.OrderNumber = this.orderDetailList.OrderNumber;
      this.OrderCargoName = this.orderDetailList.OrderCargoName;
      this.OrderCargoNumber = this.orderDetailList.OrderCargoNumber;
      this.InvoiceName = this.orderDetailList.InvoiceName;
      this.InvoiceLastName = this.orderDetailList.InvoiceLastName;
      this.InvoiceAddress = this.orderDetailList.InvoiceAddress;
      this.InvoiceCity = this.orderDetailList.InvoiceCity;
      this.InvoiceDistirct = this.orderDetailList.InvoiceDistirct;
      this.OrderSource = this.orderDetailList.OrderSource;
      this.OrderDate = this.orderDetailList.OrderDate;
      this.TotalPrice = this.orderDetailList.TotalPrice;
      this.InvoiceNumber = this.orderDetailList.InvoiceNumber;
    },
  },

  watch: {
    data(val) {
      console.log(val);
      if (val) this.getOrderDetails(val);
      return val;
    },
  },
  mounted() {
    //  this.printBarcode();
  },
};
</script>
